import styled from "@emotion/styled"

const CTAFormSpinnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background: #f8f8fb;
`

export default CTAFormSpinnerWrapper
